export const baseUrl = 'https://backend-vlabs.staging.deviare.co.za/';
export const baseAuth = 'https://vqficx91h2.execute-api.us-west-2.amazonaws.com/dev/v1/';